import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useUnit } from 'effector-react/ssr';
import { ArticlePage, articlePageModel } from '@widgets';
import { Head } from '@widgets/layout';
import { articleModel } from '@entities';
import {
	getOpenGraph,
	getOGArticleImage,
	DEFAULT_META_TITLE,
	DEFAULT_META_DESCRIPTION,
	decodeHTMLEntities,
} from '@shared/lib';
import { staticPropsFactory } from '@shared/lib/ssr';

export const Articles = React.memo(() => {
	const article = useUnit(articleModel.$article);

	const { asPath } = useRouter();

	const link = useMemo(
		() =>
			(process.env.NEXT_PUBLIC_EXTERNAL_API_HOST || '') +
			(process.env.NEXT_PUBLIC_BASE_URL || '') +
			asPath,
		[asPath]
	);

	return (
		<>
			<Head
				meta={[
					{
						type: 'title',
						content: decodeHTMLEntities(article?.seoTitle || article?.title || DEFAULT_META_TITLE),
					},
					{
						type: 'description',
						content: decodeHTMLEntities(
							article?.seoDescription || article?.preview || DEFAULT_META_DESCRIPTION
						),
						name: 'description',
					},
					...getOpenGraph({
						url: link,
						title: decodeHTMLEntities(article?.title || DEFAULT_META_TITLE),
						description: decodeHTMLEntities(article?.preview || DEFAULT_META_DESCRIPTION),
						image: getOGArticleImage(article),
					}),
				]}
				link={link}
			/>
			<Script src="https://forms.yandex.ru/_static/embed.js" />
			<ArticlePage />
		</>
	);
});

export const getStaticProps = staticPropsFactory(articlePageModel.getArticlePage);

export const getStaticPaths = async () => ({
	paths: [],
	fallback: 'blocking',
});

export default Articles;
